<template>
  <div id="app">
    <!--页面返回不刷新-->
    <!-- <transition name="slide-fade" mode="out-in"> -->
    <!-- <router-view></router-view> -->
    <!-- </transition> -->
     <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "App",
};
</script>

<style>
.slide-fade-enter-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  opacity: 1;
}
.slide-fade-leave-active {
  transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
  opacity: 0;
}
/* .slide-fade-enter, .slide-fade-leave-to
 {
  transform: translateX(10px);
  opacity: 0;
} */
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #1f1f1f;
  height: 100%;
  /* margin-top: 60px; */
}
html,
body {
  height: 100%;
}
body {
  background: #ebebeb;
}
.item-title {
  color: #1a1a1a;
}
.van-nav-bar__title {
  font-weight: bold;
}
.van-nav-bar .van-icon {
  color: #1a1a1a !important;
  font-size: 1.3rem;
}
.van-tab--active {
  color: #ff1106;
  font-weight: 500;
  font-weight: bold;
}
.van-field__label {
  color: black;
}
/* .van-nav-bar{
  background: #FF5D66;
  z-index: 10;
}
.van-nav-bar .van-icon{
  color: white;
    font-size: 2rem;
}
.van-nav-bar__title{
  color: white;
    font-weight: bold;
        font-size: 1.1rem;
}
.van-nav-bar__text{
  color: white;
      font-size: 1rem;
}
.van-cell__title{
  text-align: left;
}
.van-cell__value{
  font-size: 0.9rem;
}
.van-nav-bar__left {
    padding: 0 8px;
} */
table {
  border-collapse: collapse;
  margin-top: 1rem;
}
.van-nav-bar--fixed {
  z-index: 2;
}
.van-tabs--line .van-tabs__wrap {
  position: fixed;
  top: 46px;
  width: 100%;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/App.vue